module.exports = __webpack_public_path__ + "static/media/Edit-Trash.8833672d.svg";